import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './Openings.module.css';
import { useOpenings } from './useOpenings';
import { MeasurementsBlock } from '../../../UI/MeasurementsBlock/MeasurementsBlock';

export const Openings = memo(({}) => {
    const { openingsList, addCard } = useOpenings();

    return (
        <div className={classNames(cls.Openings)}>
            <MeasurementsBlock
                buttonTitle={i18next.t('Openings.return.buttonTitle')}
                title={i18next.t('Openings.return.title')}
                cards={openingsList}
                onClick={addCard}
                type="opening"
            />
        </div>
    );
});
